var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMwk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2677C0 13.7355 0.264047 15.1416 0.746391 16.4416L12 16.9633L23.2536 16.4416C23.736 15.1416 24 13.7355 24 12.2677C24 10.7998 23.736 9.39377 23.2536 8.09379L12 7.57202L0.746391 8.09374C0.264047 9.39377 0 10.7998 0 12.2677Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 0.267334C6.84013 0.267334 2.44161 3.52383 0.746094 8.09344H23.2534C21.5578 3.52383 17.1593 0.267334 11.9997 0.267334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2533 16.4431H0.746094C2.44161 21.0127 6.84012 24.2692 11.9997 24.2692C17.1593 24.2692 21.5578 21.0127 23.2533 16.4431Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5873 6.0074L14.1218 5.31805L14.9023 3.89872L13.3109 4.20318L13.1092 2.59546L12.0007 3.77788L10.8923 2.59546L10.6905 4.20318L9.09919 3.89872L9.87961 5.31805L8.41406 6.0074H15.5873Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMwk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MWK.775b622df4b5d525eb62da50dd110d7d.svg";